export default "__VITE_ASSET__DDedH1RB__"